import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Label } from "@atoms/label";
import { Password } from "@components/formControl/password/password";

import type { IValue } from "../types";

import type { IFastPasswordProps } from "./types";

export function FastPassword<TSchema extends object>(
  props: IFastPasswordProps<TSchema>,
) {
  const { control, name, type, isRequired, onChange: propsOnChange } = props;

  const { t } = useTranslation("field");

  const title = t(type);

  return (
    <Label text={title} htmlFor={name} isRequired={isRequired}>
      <Controller
        control={control}
        name={name}
        render={({
          field: { onBlur, ref, onChange, value, disabled },
          fieldState: { error, invalid },
        }) => (
          <Password
            value={value}
            id={name}
            onValueChange={(value) => {
              onChange(value);
              propsOnChange?.(value as IValue<TSchema>);
            }}
            onBlur={onBlur}
            ref={ref}
            disabled={disabled}
            placeholder={title}
            isInvalid={invalid}
            hintText={error?.message}
          />
        )}
      />
    </Label>
  );
}
